export default __webpack_public_path__ + "static/media/DOT.6714c6e7.png";